module.exports = __webpack_public_path__ + "img/ladder_to_rescue_cj_in_egypt.f84bddc4.jpg";